<template>
    <v-card min-width="20vw" align="center" justify="center" outlined>
        <v-card-title>
            <v-list-item>
                <v-list-item-title><h2>{{ $t('deleteStrategy') }}</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="cancelDelete" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 py-7">
            <p v-html="$t('areYouSureToDeleteStrategy',{strategyName: strategy.name})"></p>
            <v-btn @click="deleteStrategy">{{ $t('yesDeleteIt') }}</v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
    import Repository from '../../repositories/strategy';
    import { mapMutations } from 'vuex';
    export default {
        name: "DeleteStrategy",
        props: {
            strategy: Object,
        },
        methods: {
            ...mapMutations(['setStrategies']),
            async deleteStrategy() {
                await Repository.deleteStrategyToUser(this.strategy.id).then(async (response) => {
                    if(response.status < 400) {
                        if(response.data)
                            Repository.allStrategiesOfUser().then((responseAll) => {
                                this.setStrategies(responseAll.data);
                            });
                        else
                            alert(this.$t('alertMessage_DeleteStrategy'))
                    }
                });
                this.$emit('closeDeleteWindow');
            },
            cancelDelete() {
                this.$emit("closeDeleteWindow");
            },
        }
    }
</script>

<style scoped>

</style>



